/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Datatable} from '../../../components/Datatable/Datatable'
import {Button} from '../../../components/Button/Button'
import {useNavigate} from 'react-router-dom'
import {PUT, POST, DELETE} from '../../../services/api'
import useModals from '../../../hooks/useModals'
import {Loading} from '../../../components/Loading/Loading'

import {i18n} from '../../../translate/i18n'
import {Input} from '../../../components/Input/Input'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {init} from 'i18next'

import {ModalDelete} from '../../../components/Modals/General/ModalDelete/ModalDelete'
import Swal from 'sweetalert2'

type ServiceClassificationType = {
  id: number
  pluginspaceId: number
  name: string
  status: boolean
  description: string
  order: number
  code: string
}

type ServiceType = {
  id: number
  pluginspaceId: number
  serviceClassificationId: number
  name: string
  code: string
  iconId: number
  description: string
  status: boolean
  order: number
  createdAt: string | null
  updatedAt: string | null
  deletedAt: string | null
  serviceClassification: ServiceClassificationType
  visibleTo?: 'employees' | 'customers' | 'both'
}

type categories = {
  value: string
  select: string
}

const ListarServicosContent: FC = () => {
  const navigate = useNavigate()

  const {showDeleteModal} = useModals()
  const [loading, setLoading] = useState(false)
  const [services, setServices] = useState<ServiceType[]>([])
  const [id, setId] = useState<number | null>(null)
  const [filterCategoria, setFilterCategoria] = useState<any>({
    label: i18n.t('service_list.filters.all_categories'),
    value: 0,
  })
  const [categoria, setCategoria] = useState<categories[]>([])

  const switchStatus = async (service: ServiceType, status: boolean) => {
    try {
      const switchProduct = await PUT(`/hotel-service/${service.id}`, {
        status: !status,
      })
      if (switchProduct.success) {
        const newProducts = services.map((product) => {
          if (product.id === service.id) {
            product.status = !status
          }
          return product
        })
        setServices(newProducts)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getCategories = async () => {
    try {
      const resCategorias = await POST(`/service-classification/filter`)

      const categories = resCategorias.data.map((el: any) => {
        return {
          value: el.id,
          select: el.name,
        }
      })

      categories.push({
        select: i18n.t('service_list.filters.all_categories'),
        value: 0,
      })

      setCategoria(categories)
    } catch (error) {
      console.log(error)
    }
  }

  const deleteService = async () => {
    try {
      if (!id) return
      setLoading(true)
      const res = await DELETE(`/hotel-service/${id}`)
      if (res && res.success) {
        Swal.fire({
          icon: 'success',
          title: String(i18n.t('general.success')),
          text: String(i18n.t('Deleção realizada com sucesso')),
        })
        await getAllData()
      } else {
        Swal.fire({
          icon: 'error',
          title: String(i18n.t('general.error')),
          text: String(i18n.t('Erro ao realizar a deleção')),
        })
        await getAllData()
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('general.error')),
        text: String(i18n.t('Erro ao realizar a deleção')),
      })
      await getAllData()
    }
  }

  const getList = async () => {
    try {
      setLoading(true)
      const res = await POST('/hotel-service/filter', {
        classificationId: filterCategoria.value,
      })
      const list: ServiceType[] = res.data.map((row: ServiceType) => {
        return {
          ...row,
          category:
            row.serviceClassification && row.serviceClassification.name
              ? row.serviceClassification.name
              : '',
          visibleToText:
            row.visibleTo === 'employees'
              ? i18n.t('service_requests.visible_to_employees')
              : row.visibleTo === 'customers'
              ? i18n.t('service_requests.visible_to_customers')
              : i18n.t('service_requests.visible_to_both'),
        }
      })
      setServices(list)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  async function getAllData() {
    setLoading(true)

    await Promise.all([getList(), getCategories()])

    setLoading(false)
  }

  useEffect(() => {
    getAllData()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`permissions.service`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(`smart_order.service_title`)}
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text={i18n.t(`buttons.add_service`)}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/hospitality/service-item/create')}
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <div className='d-flex align-items-center justify-content-start'>
                <div className='d-flex w-25 '>
                  <div className=' align-items-end  justify-content-start me-5 flex-grow-1'>
                    <span className='align-self-start'>
                      {i18n.t('service_list.filters.categories')}
                    </span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      options={categoria}
                      placeholder={i18n.t('service_list.filters.category_placeholder')}
                      search={true}
                      value={filterCategoria}
                      change={(value: any) => setFilterCategoria(value)}
                    />
                  </div>
                </div>

                <div
                  className='d-flex align-items-end w-100 justify-content-end h-100'
                  style={{
                    marginTop: '48px',
                  }}
                >
                  <Button
                    text={i18n.t('service_list.filters.filter_button')}
                    color='primary'
                    iconColor='#FFF'
                    icon='fas fa-filter'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => getList()}
                    btnClass='mb-0 fw-bolder'
                  />
                </div>
              </div>
              <Datatable
                data={services}
                headers={[
                  {key: i18n.t(`smart_order.name`), value: 'name', type: 'default'},
                  {key: i18n.t('service_list.table.schedule'), value: 'time', type: 'default'},
                  {key: i18n.t('service_list.table.extension'), value: 'ramal', type: 'default'},
                  {key: i18n.t(`smart_order.category`), value: 'category', type: 'default'},
                  {
                    key: i18n.t(`general.active`),
                    value: 'status',
                    type: 'check',
                    action: (item) => switchStatus(item, item.status),
                  },
                  {
                    key: i18n.t('service_requests.visible_to_label'),
                    value: 'visibleToText',
                    type: 'default',
                  },
                  {key: i18n.t(`general.actions`), value: 'acoes', type: ''},
                ]}
                options={[
                  {
                    icon: 'fas fa-pen',
                    title: '',
                    action: (item) => {
                      navigate(`/hospitality/service-item/update/${item.id}`)
                    },
                  },
                  {
                    icon: 'fas fa-trash',
                    action: (item: any) => {
                      showDeleteModal(String(i18n.t('booking_hotel_services.delete_confirm')))
                      setId(item.id)
                    },
                    title: i18n.t('service_list.actions.delete_service'),
                  },
                ]}
                color='primary'
                // onChangeData={async (take, page, search) => await getProducts(take, page, search)}
                // search
              />
            </div>
          </div>
        </div>
      )}
      <ModalDelete confirmAction={() => deleteService()} />
    </>
  )
}

const ListarServicos: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`permissions.service`),
            path: 'service-item',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`permissions.service`)}
      </PageTitle>
      <ListarServicosContent />
    </>
  )
}

export {ListarServicos}
